import {
  Accordion as UQAccordion,
  Body as UQBody,
  ButtonLayout as UQButtonLayout,
  Button as UQButton,
  ButtonFloating as UQButtonFloating,
  ButtonToggle as UQButtonToggle,
  ButtonToggleGroup as UQButtonToggleGroup,
  Breadcrumb as UQBreadcrumb,
  BreadcrumbGroup as UQBreadcrumbGroup,
  CmsSpacer as UQCmsSpacer,
  Checkbox as UQCheckbox,
  CheckboxGroup as UQCheckboxGroup,
  Display as UQDisplay,
  FileInput as UQFileInput,
  Footer as UQFooter,
  FlagText as UQFlagText,
  GutterContainer as UQGutterContainer,
  HeaderPage as UQHeaderPage,
  IconTypography as UQIconTypography,
  Image as UQImage,
  ImageEnhancements as UQImageEnhancements,
  ItemTag as UQItemTag,
  ItemTags as UQItemTags,
  Keyline as UQKeyline,
  Label as UQLabel,
  Layout as UQLayout,
  LinkImage as UQLinkImage,
  LinkText as UQLinkText,
  LinkNavigation as UQLinkNavigation,
  LinkNavigationGroup as UQLinkNavigationGroup,
  List as UQList,
  LoadingIndicator as UQLoadingIndicator,
  Modal as UQModal,
  MediaObject as UQMediaObject,
  NavigationHeader as UQNavigationHeader,
  ProductCollection as UQProductCollection,
  ProductTile as UQProductTile,
  Radio as UQRadio,
  RadioGroup as UQRadioGroup,
  Spacer as UQSpacer,
  StickyContainer as UQStickyContainer,
  StylingGrid as UQStylingGrid,
  Tab as UQTab,
  TagFilter as UQTagFilter,
  TabGroup as UQTabGroup,
  TagFilterGroup as UQTagFilterGroup,
  Tile as UQTile,
  Title as UQTitle,
  TextArea as UQTextArea,
  Toast as UQToast,
  Icon as UQIcon,
  TemplateFullGutter as UQTemplateFullGutter,
  UtilityBar as UQUtilityBar,
  Drawer as UQDrawer,
  CollectionList as UQCollectionList,
  Dropdown as UQDropdown,
  Chip as UQChip,
  ChipGroup as UQChipGroup,
  TemplateInformation as UQTemplateInformation,
  Price as UQPrice,
  RatingStatic as UQRatingStatic,
  Tag as UQTag,
  LayoutWrapper as UQLayoutWrapper
} from "uq-global-ec-uikit/components/react";
import {
  Accordion as GUAccordion,
  Body as GUBody,
  Button as GUButton,
  ButtonFloating as GUButtonFloating,
  ButtonLayout as GUButtonLayout,
  ButtonToggle as GUButtonToggle,
  ButtonToggleGroup as GUButtonToggleGroup,
  Breadcrumb as GUBreadcrumb,
  BreadcrumbGroup as GUBreadcrumbGroup,
  CmsSpacer as GUCmsSpacer,
  Checkbox as GUCheckbox,
  CheckboxGroup as GUCheckboxGroup,
  Display as GUDisplay,
  FileInput as GUFileInput,
  Footer as GUFooter,
  FlagText as GUFlagText,
  GutterContainer as GUGutterContainer,
  HeaderPage as GUHeaderPage,
  IconTypography as GUIconTypography,
  Image as GUImage,
  ImageEnhancements as GUImageEnhancements,
  ItemTag as GUItemTag,
  ItemTags as GUItemTags,
  Keyline as GUKeyline,
  Label as GULabel,
  Layout as GULayout,
  LinkImage as GULinkImage,
  LinkText as GULinkText,
  LinkNavigation as GULinkNavigation,
  LinkNavigationGroup as GULinkNavigationGroup,
  List as GUList,
  LoadingIndicator as GULoadingIndicator,
  Modal as GUModal,
  MediaObject as GUMediaObject,
  NavigationHeader as GUNavigationHeader,
  ProductCollection as GUProductCollection,
  ProductTile as GUProductTile,
  Radio as GURadio,
  RadioGroup as GURadioGroup,
  Spacer as GUSpacer,
  StickyContainer as GUStickyContainer,
  StylingGrid as GUStylingGrid,
  Tab as GUTab,
  TagFilter as GUTagFilter,
  TabGroup as GUTabGroup,
  TagFilterGroup as GUTagFilterGroup,
  Tile as GUTile,
  Title as GUTitle,
  TextArea as GUTextArea,
  Toast as GUToast,
  Icon as GUIcon,
  TemplateFullGutter as GUTemplateFullGutter,
  UtilityBar as GUUtilityBar,
  Drawer as GUDrawer,
  CollectionList as GUCollectionList,
  Dropdown as GUDropdown,
  TemplateInformation as GUTemplateInformation,
  Chip as GUChip,
  ChipGroup as GUChipGroup,
  Price as GUPrice,
  RatingStatic as GURatingStatic,
  Tag as GUTag,
  LayoutWrapper as GULayoutWrapper
} from "gu-global-ec-uikit/components/react";
import { getBrand } from "@util/common";

const getCurrentComponent = (UQComponent: any, GUComponent: any) => {
  switch (getBrand().toUpperCase()) {
    case "UQ":
      return UQComponent;
    case "GU":
      return GUComponent;
    // case "PL":
    //   return import("../PLLayout");
    default:
      return UQComponent;
  }
};

export const Accordion = getCurrentComponent(UQAccordion, GUAccordion);
export const Body = getCurrentComponent(UQBody, GUBody);
export const Button = getCurrentComponent(UQButton, GUButton);
export const ButtonFloating = getCurrentComponent(
  UQButtonFloating,
  GUButtonFloating
);
export const ButtonLayout = getCurrentComponent(UQButtonLayout, GUButtonLayout);
export const ButtonToggle = getCurrentComponent(UQButtonToggle, GUButtonToggle);
export const ButtonToggleGroup = getCurrentComponent(
  UQButtonToggleGroup,
  GUButtonToggleGroup
);
export const Breadcrumb = getCurrentComponent(UQBreadcrumb, GUBreadcrumb);
export const BreadcrumbGroup = getCurrentComponent(
  UQBreadcrumbGroup,
  GUBreadcrumbGroup
);
export const CmsSpacer = getCurrentComponent(UQCmsSpacer, GUCmsSpacer);
export const Checkbox = getCurrentComponent(UQCheckbox, GUCheckbox);
export const CheckboxGroup = getCurrentComponent(
  UQCheckboxGroup,
  GUCheckboxGroup
);
export const Display = getCurrentComponent(UQDisplay, GUDisplay);
export const FileInput = getCurrentComponent(UQFileInput, GUFileInput);
export const Footer = getCurrentComponent(UQFooter, GUFooter);
export const FlagText = getCurrentComponent(UQFlagText, GUFlagText);
export const GutterContainer = getCurrentComponent(
  UQGutterContainer,
  GUGutterContainer
);
export const HeaderPage = getCurrentComponent(UQHeaderPage, GUHeaderPage);
export const IconTypography = getCurrentComponent(
  UQIconTypography,
  GUIconTypography
);
export const Image = getCurrentComponent(UQImage, GUImage);
export const ImageEnhancements = getCurrentComponent(
  UQImageEnhancements,
  GUImageEnhancements
);
export const ItemTag = getCurrentComponent(UQItemTag, GUItemTag);
export const ItemTags = getCurrentComponent(UQItemTags, GUItemTags);
export const Keyline = getCurrentComponent(UQKeyline, GUKeyline);
export const Label = getCurrentComponent(UQLabel, GULabel);
export const Layout = getCurrentComponent(UQLayout, GULayout);
export const LinkImage = getCurrentComponent(UQLinkImage, GULinkImage);
export const LinkText = getCurrentComponent(UQLinkText, GULinkText);
export const LinkNavigation = getCurrentComponent(
  UQLinkNavigation,
  GULinkNavigation
);
export const LinkNavigationGroup = getCurrentComponent(
  UQLinkNavigationGroup,
  GULinkNavigationGroup
);
export const List = getCurrentComponent(UQList, GUList);
export const LoadingIndicator = getCurrentComponent(
  UQLoadingIndicator,
  GULoadingIndicator
);
export const NavigationHeader = getCurrentComponent(
  UQNavigationHeader,
  GUNavigationHeader
);
export const Modal = getCurrentComponent(UQModal, GUModal);
export const MediaObject = getCurrentComponent(UQMediaObject, GUMediaObject);
export const ProductCollection = getCurrentComponent(
  UQProductCollection,
  GUProductCollection
);
export const ProductTile = getCurrentComponent(UQProductTile, GUProductTile);
export const Radio = getCurrentComponent(UQRadio, GURadio);
export const RadioGroup = getCurrentComponent(UQRadioGroup, GURadioGroup);
export const Spacer = getCurrentComponent(UQSpacer, GUSpacer);
export const StylingGrid = getCurrentComponent(UQStylingGrid, GUStylingGrid);
export const StickyContainer = getCurrentComponent(
  UQStickyContainer,
  GUStickyContainer
);
export const Tab = getCurrentComponent(UQTab, GUTab);
export const TagFilter = getCurrentComponent(UQTagFilter, GUTagFilter);
export const TabGroup = getCurrentComponent(UQTabGroup, GUTabGroup);
export const TagFilterGroup = getCurrentComponent(
  UQTagFilterGroup,
  GUTagFilterGroup
);
export const Tile = getCurrentComponent(UQTile, GUTile);
export const Title = getCurrentComponent(UQTitle, GUTitle);
export const TextArea = getCurrentComponent(UQTextArea, GUTextArea);
export const Toast = getCurrentComponent(UQToast, GUToast);
export const Icon = getCurrentComponent(UQIcon, GUIcon);
export const TemplateFullGutter = getCurrentComponent(
  UQTemplateFullGutter,
  GUTemplateFullGutter
);
export const UtilityBar = getCurrentComponent(UQUtilityBar, GUUtilityBar);
export const Drawer = getCurrentComponent(UQDrawer, GUDrawer);
export const CollectionList = getCurrentComponent(
  UQCollectionList,
  GUCollectionList
);
export const Dropdown = getCurrentComponent(UQDropdown, GUDropdown);
export const TemplateInformation = getCurrentComponent(
  UQTemplateInformation,
  GUTemplateInformation
);
export const Chip = getCurrentComponent(UQChip, GUChip);
export const ChipGroup = getCurrentComponent(UQChipGroup, GUChipGroup);

export const Price = getCurrentComponent(UQPrice, GUPrice);

export const RatingStatic = getCurrentComponent(UQRatingStatic, GURatingStatic);

export const Tag = getCurrentComponent(UQTag, GUTag);

export const LayoutWrapper = getCurrentComponent(
  UQLayoutWrapper,
  GULayoutWrapper
);
